/**
 * <h2>PATCHES</h2>
 * - !!! nicht als PATCH markiert, zuviele Stellen: statt var sind diverse funktionen jetzt an this / scope gebunden
 * - Um Übergabe-Callback setDirty erweitert, für Abwärtskompatibilität mit älterer Patch-Version
 * - Um Property polarAngleLocked true/false erweitert (Horizontale Mouse-Bewegung hat dann keinen Effekt mehr)
 * - processTarget ist ein Callback, um die Target-Position zu verändern, wird verwendet für die Stage-Option
 * ignoreBindOrbitControlToYPlaneWithHeight
 * - setEnabled zum Ein/Ausschalten der OrbitControls (z.b. während eines Drag-Vorganges)
 * - zusätzliche public methods
 * - Mouse- statt Pointerevents
 *
 * Code-Stand: irgendwas zwischen 127 und 132..
 *
 */

// This set of controls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
//
//    Orbit - left mouse / touch: one-finger move
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - right mouse, or left mouse + ctrl/meta/shiftKey, or arrow keys / touch: two-finger move

const _changeEvent = {
    type: 'change'
};
const _startEvent = {
    type: 'start'
};
const _endEvent = {
    type: 'end'
};

// ---------------------------------------------
// PATCH - optionales setDirty
// ---------------------------------------------
class OrbitControls extends THREE.EventDispatcher {

    constructor(object, domElement, setDirty = null, registerDefaultKeylistnener = true) {

        super();

        if (domElement === undefined) console.warn('THREE.OrbitControls: The second parameter "domElement" is now mandatory.');
        if (domElement === document) console.error('THREE.OrbitControls: "document" should not be used as the target "domElement". Please use "renderer.domElement" instead.');

        if (setDirty) {
            this.addEventListener('change', setDirty);
        }
        // ---------------------------------------------

        this.object = object;

        // ---------------------------------------------
        // PATCH - jDom-Elemente akzeptieren
        // ---------------------------------------------
        this.domElement = (domElement !== undefined) ? $(domElement)[0] : document;
        // ---------------------------------------------
        // ---------------------------------------------
        // für Surface - touch events werden von OrbitControl verarbeitet
        // ---------------------------------------------
        this.domElement.style.touchAction = 'none'; // disable touch scroll
        $(this.domElement).parent().addClass('noTouchAction');
        // ---------------------------------------------

        // Set to false to disable this control
        this.enabled = true;

        // "target" sets the location of focus, where the object orbits around
        this.target = new THREE.Vector3();

        // How far you can dolly in and out ( PerspectiveCamera only )
        this.minDistance = 0;
        this.maxDistance = Infinity;

        // How far you can zoom in and out ( OrthographicCamera only )
        this.minZoom = 0;
        this.maxZoom = Infinity;

        // How far you can orbit vertically, upper and lower limits.
        // Range is 0 to Math.PI radians.
        this.minPolarAngle = 0; // radians
        this.maxPolarAngle = Math.PI; // radians

        // ---------------------------------------------
        // PATCH - polarAngleLocked
        // ---------------------------------------------
        this.polarAngleLocked = false;
        // ---------------------------------------------
        // ---------------------------------------------
        // PATCH - minCameraPosition und maxCameraPosition sowie minCameraTargetPosition und maxCameraTargetPosition
        // ---------------------------------------------
        this.minCameraTargetPosition = new THREE.Vector3(-Infinity, -Infinity, -Infinity);
        this.maxCameraTargetPosition = new THREE.Vector3(Infinity, Infinity, Infinity);
        this.minCameraPosition = new THREE.Vector3(-Infinity, -Infinity, -Infinity);
        this.maxCameraPosition = new THREE.Vector3(Infinity, Infinity, Infinity);
        // ---------------------------------------------

        // How far you can orbit horizontally, upper and lower limits.
        // If set, must be a sub-interval of the interval [ - Math.PI, Math.PI ].
        this.minAzimuthAngle = -Infinity; // radians
        this.maxAzimuthAngle = Infinity; // radians

        // Set to true to enable damping (inertia)
        // If damping is enabled, you must call controls.update() in your animation loop
        this.enableDamping = false;
        this.dampingFactor = 0.05;

        // This option actually enables dollying in and out; left as "zoom" for backwards compatibility.
        // Set to false to disable zooming
        this.enableZoom = true;
        this.zoomSpeed = 1.0;

        // Set to false to disable rotating
        this.enableRotate = true;
        this.rotateSpeed = 1.0;

        // Set to false to disable panning
        this.enablePan = true;
        this.panSpeed = 1.0;

        // ---------------------------------------------
        // PATCH - altes Verhalten ist defaultmässig erwünscht
        // ---------------------------------------------
        this.screenSpacePanning = true; // if true, pan in screen-space
        // ---------------------------------------------

        this.keyPanSpeed = 7.0;	// pixels moved per arrow key push

        // Set to true to automatically rotate around the target
        // If auto-rotate is enabled, you must call controls.update() in your animation loop
        this.autoRotate = false;
        this.autoRotateSpeed = 2.0; // 30 seconds per round when fps is 60

        // The four arrow keys
        this.keys = {LEFT: 37, UP: 38, RIGHT: 39, BOTTOM: 40};

        // Mouse buttons
        this.mouseButtons = {
            LEFT: THREE.MOUSE.ROTATE,
            MIDDLE: THREE.MOUSE.DOLLY,
            RIGHT: THREE.MOUSE.PAN
        };

        // Touch fingers
        this.touches = {ONE: THREE.TOUCH.ROTATE, TWO: THREE.TOUCH.DOLLY_PAN};

        // for reset
        this.target0 = this.target.clone();
        this.position0 = this.object.position.clone();
        this.zoom0 = this.object.zoom;

        // the target DOM element for key events
        this._domElementKeyEvents = null;

        //
        // public methods
        //

        this.getPolarAngle = function () {

            return spherical.phi;

        };

        this.getAzimuthalAngle = function () {

            return spherical.theta;

        };

        this.getDistance = function () {

            return this.object.position.distanceTo(this.target);

        };

        this.listenToKeyEvents = function (domElement) {

            domElement.addEventListener('keydown', onKeyDown);
            this._domElementKeyEvents = domElement;

        };

        this.saveState = function () {

            scope.target0.copy(scope.target);
            scope.position0.copy(scope.object.position);
            scope.zoom0 = scope.object.zoom;

        };

        this.reset = function () {

            scope.target.copy(scope.target0);
            scope.object.position.copy(scope.position0);
            scope.object.zoom = scope.zoom0;

            this.resetFromObjectAndTarget();
        };

        // ---------------------------------------------
        // PATCH - resetFromObjectAndTarget
        // ---------------------------------------------
        this.resetFromObjectAndTarget = function () {
            scope.object.updateProjectionMatrix();
            scope.dispatchEvent(changeEvent);

            scope.update();

            scope.state = STATE.NONE;
        };
        // ---------------------------------------------

        // this method is exposed, but perhaps it would be better if we can make it private...
        this.update = function () {

            const offset = new THREE.Vector3();

            // so camera.up is the orbit axis
            const quat = new THREE.Quaternion().setFromUnitVectors(object.up, new THREE.Vector3(0, 1, 0));
            const quatInverse = quat.clone().invert();

            const lastPosition = new THREE.Vector3();
            const lastQuaternion = new THREE.Quaternion();

            const twoPI = 2 * Math.PI;

            return function update() {

                //     if (!scope.enabled) {
                //       return;
                //    }

                const position = scope.object.position;

                offset.copy(position).sub(scope.target);

                // rotate offset to "y-axis-is-up" space
                offset.applyQuaternion(quat);

                // angle from z-axis around y-axis
                spherical.setFromVector3(offset);

                if (scope.autoRotate && scope.state === STATE.NONE) {

                    scope.rotateLeft(scope.getAutoRotationAngle());

                }

                if (scope.enableDamping) {

                    spherical.theta += sphericalDelta.theta * scope.dampingFactor;
                    // ---------------------------------------------
                    // PATCH - polarAngleLocked
                    // ---------------------------------------------
                    if (!scope.polarAngleLocked) {
                        spherical.phi += sphericalDelta.phi * scope.dampingFactor;
                    }
                    // ---------------------------------------------

                } else {

                    spherical.theta += sphericalDelta.theta;
                    // ---------------------------------------------
                    // PATCH - polarAngleLocked
                    // ---------------------------------------------
                    if (!scope.polarAngleLocked) {
                        spherical.phi += sphericalDelta.phi;
                    }
                    // ---------------------------------------------

                }

                // restrict theta to be between desired limits
                /* PATCH
                   der hier auskommentierte neue Code klappt nicht, Kamera ist gelocked in einem kleinen Bereich.
                   Vielleicht sind bei uns die Werte aus neuer Sicht nicht mehr richtig angegeben? Jedenfalls aus
                   Gründen der Backward-Kompatibilität zurück zum alten Stand:
                var min = scope.minAzimuthAngle;
                var max = scope.maxAzimuthAngle;

                if ( isFinite( min ) && isFinite( max ) ) {

                    if ( min < - Math.PI ) min += twoPI; else if ( min > Math.PI ) min -= twoPI;

                    if ( max < - Math.PI ) max += twoPI; else if ( max > Math.PI ) max -= twoPI;

                    if ( min <= max ) {

                        spherical.theta = Math.max( min, Math.min( max, spherical.theta ) );

                    } else {

                        spherical.theta = ( spherical.theta > ( min + max ) / 2 ) ?
                            Math.max( min, spherical.theta ) :
                            Math.min( max, spherical.theta );

                    }

                }
                */
                spherical.theta = Math.max(scope.minAzimuthAngle, Math.min(scope.maxAzimuthAngle, spherical.theta));

                // restrict phi to be between desired limits
                spherical.phi = Math.max(scope.minPolarAngle, Math.min(scope.maxPolarAngle, spherical.phi));

                spherical.makeSafe();


                spherical.radius *= scale;

                // restrict radius to be between desired limits
                spherical.radius = Math.max(scope.minDistance, Math.min(scope.maxDistance, spherical.radius));

                // move target to panned location

                if (scope.enableDamping === true) {

                    scope.target.addScaledVector(panOffset, scope.dampingFactor);

                } else {

                    scope.target.add(panOffset);

                }

                offset.setFromSpherical(spherical);

                // rotate offset back to "camera-up-vector-is-up" space
                offset.applyQuaternion(quatInverse);

                // ---------------------------------------------
                // PATCH - clamp target to minCameraTargetPosition and maxCameraTargetPosition
                // ---------------------------------------------
                scope.target.clamp(this.minCameraTargetPosition, this.maxCameraTargetPosition);
                // ---------------------------------------------

                position.copy(scope.target).add(offset);

                // ---------------------------------------------
                // PATCH - clamp position to minCameraPosition and maxCameraPosition
                // ---------------------------------------------
                position.clamp(this.minCameraPosition, this.maxCameraPosition);
                // ---------------------------------------------


                // ---------------------------------------------
                // PATCH - processTarget
                // ---------------------------------------------
                scope.processTarget(scope.target);
                // ---------------------------------------------

                scope.object.lookAt(scope.target);

                if (scope.enableDamping === true) {

                    sphericalDelta.theta *= (1 - scope.dampingFactor);
                    sphericalDelta.phi *= (1 - scope.dampingFactor);

                    panOffset.multiplyScalar(1 - scope.dampingFactor);

                } else {

                    sphericalDelta.set(0, 0, 0);

                    panOffset.set(0, 0, 0);

                }

                scale = 1;

                // update condition is:
                // min(camera displacement, camera rotation in radians)^2 > EPS
                // using small-angle approximation cos(x/2) = 1 - x^2 / 8

                if (zoomChanged ||
                    lastPosition.distanceToSquared(scope.object.position) > EPS ||
                    8 * (1 - lastQuaternion.dot(scope.object.quaternion)) > EPS) {

                    scope.dispatchEvent(changeEvent);

                    lastPosition.copy(scope.object.position);
                    lastQuaternion.copy(scope.object.quaternion);
                    zoomChanged = false;

                    return true;

                }

                return false;

            };

        }();

        this.dispose = function () {

            scope.domElement.removeEventListener('contextmenu', onContextMenu);
            // ---------------------------------------------
            // PATCH - mouse statt pointer events, sonst kracht es mit pantouch
            // ---------------------------------------------
            scope.domElement.removeEventListener('mousedown', onMouseDown);
            // ---------------------------------------------
            scope.domElement.removeEventListener('wheel', onMouseWheel);

            scope.domElement.removeEventListener('touchstart', onTouchStart);
            scope.domElement.removeEventListener('touchend', onTouchEnd);
            scope.domElement.removeEventListener('touchmove', onTouchMove);

            // ---------------------------------------------
            // PATCH - mouse statt pointer events, sonst kracht es mit pantouch
            // ---------------------------------------------
            scope.domElement.ownerDocument.removeEventListener('mousemove', onMouseMove);
            scope.domElement.ownerDocument.removeEventListener('mouseup', onMouseUp);
            // ---------------------------------------------

            if (scope._domElementKeyEvents !== null) {
                scope._domElementKeyEvents.removeEventListener('keydown', onKeyDown);
            }

            //scope.dispatchEvent( { type: 'dispose' } ); // should this be added here?

        };

        //
        // internals
        //

        const scope = this;

        const changeEvent = {type: 'change'};
        const startEvent = {type: 'start'};
        const endEvent = {type: 'end'};

        const STATE = {
            NONE: -1,
            ROTATE: 0,
            DOLLY: 1,
            PAN: 2,
            TOUCH_ROTATE: 3,
            TOUCH_PAN: 4,
            TOUCH_DOLLY_PAN: 5,
            TOUCH_DOLLY_ROTATE: 6
        };

        // ---------------------------------------------
        // state exportieren
        // ---------------------------------------------
        this.STATE = STATE;

        this._state = STATE.NONE;
        Object.defineProperty(this, 'state', {
            get() {
                return this._state;
            },
            set(v) {
                if (this._state !== v) {
                    STAGE.trigger(v === STATE.NONE ? 'orbitControlsEnd' : 'orbitControlsStart', v);
                }
                this._state = v;
            },
        });
        // ---------------------------------------------

        const EPS = 0.000001;

        // current position in spherical coordinates
        const spherical = new THREE.Spherical();
        const sphericalDelta = new THREE.Spherical();

        let scale = 1;
        const panOffset = new THREE.Vector3();
        let zoomChanged = false;

        const rotateStart = new THREE.Vector2();
        const rotateEnd = new THREE.Vector2();
        const rotateDelta = new THREE.Vector2();

        const panStart = new THREE.Vector2();
        const panEnd = new THREE.Vector2();
        const panDelta = new THREE.Vector2();

        const dollyStart = new THREE.Vector2();
        const dollyEnd = new THREE.Vector2();
        const dollyDelta = new THREE.Vector2();

        this.getAutoRotationAngle = function () {

            return 2 * Math.PI / 60 / 60 * scope.autoRotateSpeed;

        }

        this.getZoomScale = function () {

            return Math.pow(0.95, scope.zoomSpeed);

        }

        this.rotateLeft = function (angle) {

            sphericalDelta.theta -= angle;

        }

        this.rotateUp = function (angle) {

            sphericalDelta.phi -= angle;

        }

        this.panLeft = function () {

            const v = new THREE.Vector3();

            return function panLeft(distance, objectMatrix) {

                v.setFromMatrixColumn(objectMatrix, 0); // get X column of objectMatrix
                v.multiplyScalar(-distance);

                panOffset.add(v);

            };

        }();

        this.panUp = function () {

            const v = new THREE.Vector3();

            return function panUp(distance, objectMatrix) {

                if (scope.screenSpacePanning === true) {

                    v.setFromMatrixColumn(objectMatrix, 1);

                } else {

                    v.setFromMatrixColumn(objectMatrix, 0);
                    v.crossVectors(scope.object.up, v);

                }

                v.multiplyScalar(distance);

                panOffset.add(v);

            };

        }();

        // deltaX and deltaY are in pixels; right and down are positive
        this.pan = function () {

            const offset = new THREE.Vector3();

            return function pan(deltaX, deltaY) {

                const element = scope.domElement;

                if (scope.object.isPerspectiveCamera) {

                    // perspective
                    const position = scope.object.position;
                    offset.copy(position).sub(scope.target);
                    let targetDistance = offset.length();

                    // half of the fov is center to top of screen
                    targetDistance *= Math.tan((scope.object.fov / 2) * Math.PI / 180.0);

                    // we use only clientHeight here so aspect ratio does not distort speed
                    scope.panLeft(2 * deltaX * targetDistance / element.clientHeight, scope.object.matrix);
                    scope.panUp(2 * deltaY * targetDistance / element.clientHeight, scope.object.matrix);

                } else if (scope.object.isOrthographicCamera) {

                    // orthographic
                    scope.panLeft(deltaX * (scope.object.right - scope.object.left) / scope.object.zoom / element.clientWidth, scope.object.matrix);
                    scope.panUp(deltaY * (scope.object.top - scope.object.bottom) / scope.object.zoom / element.clientHeight, scope.object.matrix);

                } else {

                    // camera neither orthographic nor perspective
                    console.warn('WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.');
                    scope.enablePan = false;

                }

            };

        }();

        this.dollyIn = function (dollyScale) {

            if (scope.object.isPerspectiveCamera) {

                scale /= dollyScale;

                // ---------------------------------------------
                // PATCH - fehlte
                // ---------------------------------------------
                zoomChanged = true;
                // ---------------------------------------------

            } else if (scope.object.isOrthographicCamera) {

                scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom * dollyScale));
                scope.object.updateProjectionMatrix();
                zoomChanged = true;

            } else {

                console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
                scope.enableZoom = false;

            }

        }

        this.dollyOut = function (dollyScale) {

            if (scope.object.isPerspectiveCamera) {

                scale *= dollyScale;

                // ---------------------------------------------
                // PATCH - fehlte
                // ---------------------------------------------
                zoomChanged = true;
                // ---------------------------------------------

            } else if (scope.object.isOrthographicCamera) {

                scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom / dollyScale));
                scope.object.updateProjectionMatrix();
                zoomChanged = true;

            } else {

                console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
                scope.enableZoom = false;

            }

        }

        // ---------------------------------------------
        // PATCH - mouse statt pointer events, sonst kracht es mit pantouch
        // ---------------------------------------------
        this.removeUpEventListeners = function () {
            scope.domElement.ownerDocument.removeEventListener('mousemove', onMouseMove);
            scope.domElement.ownerDocument.removeEventListener('mouseup', onMouseUp);
        }
        // ---------------------------------------------

        //
        // event callbacks - update the object state
        //

        function handleMouseDownRotate(event) {

            rotateStart.set(event.clientX, event.clientY);

        }

        function handleMouseDownDolly(event) {

            dollyStart.set(event.clientX, event.clientY);

        }

        function handleMouseDownPan(event) {

            panStart.set(event.clientX, event.clientY);

        }

        function handleMouseMoveRotate(event) {

            rotateEnd.set(event.clientX, event.clientY);

            rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);

            const element = scope.domElement;

            // rotating across whole screen goes 360 degrees around
            scope.rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight); // yes, height

            // rotating up and down along whole screen attempts to go 360, but limited to 180
            scope.rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);

            rotateStart.copy(rotateEnd);

            scope.update();

        }

        function handleMouseMoveDolly(event) {

            dollyEnd.set(event.clientX, event.clientY);

            dollyDelta.subVectors(dollyEnd, dollyStart);

            if (dollyDelta.y > 0) {

                scope.dollyIn(scope.getZoomScale());

            } else if (dollyDelta.y < 0) {

                scope.dollyOut(scope.getZoomScale());

            }

            dollyStart.copy(dollyEnd);

            scope.update();

        }

        function handleMouseMovePan(event) {

            panEnd.set(event.clientX, event.clientY);

            panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);

            scope.pan(panDelta.x, panDelta.y);

            panStart.copy(panEnd);

            scope.update();

        }

        function handleMouseUp(event) {

            // no-op

        }

        function handleMouseWheel(event) {

            if (event.deltaY < 0) {

                scope.dollyOut(scope.getZoomScale());

            } else if (event.deltaY > 0) {

                scope.dollyIn(scope.getZoomScale());

            }

            scope.update();

        }

        function handleKeyDown(event) {

            let needsUpdate = false;

            switch (event.code) {

                case scope.keys.UP:
                    scope.pan(0, scope.keyPanSpeed);
                    needsUpdate = true;
                    break;

                case scope.keys.BOTTOM:
                    scope.pan(0, -scope.keyPanSpeed);
                    needsUpdate = true;
                    break;

                case scope.keys.LEFT:
                    scope.pan(scope.keyPanSpeed, 0);
                    needsUpdate = true;
                    break;

                case scope.keys.RIGHT:
                    scope.pan(-scope.keyPanSpeed, 0);
                    needsUpdate = true;
                    break;

            }

            if (needsUpdate) {

                // prevent the browser from scrolling on cursor keys
                event.preventDefault();

                scope.update();

            }


        }

        function handleTouchStartRotate(event) {

            if (event.touches.length == 1) {

                rotateStart.set(event.touches[0].pageX, event.touches[0].pageY);

            } else {

                const x = 0.5 * (event.touches[0].pageX + event.touches[1].pageX);
                const y = 0.5 * (event.touches[0].pageY + event.touches[1].pageY);

                rotateStart.set(x, y);

            }

        }

        function handleTouchStartPan(event) {

            if (event.touches.length == 1) {

                panStart.set(event.touches[0].pageX, event.touches[0].pageY);

            } else {

                const x = 0.5 * (event.touches[0].pageX + event.touches[1].pageX);
                const y = 0.5 * (event.touches[0].pageY + event.touches[1].pageY);

                panStart.set(x, y);

            }

        }

        function handleTouchStartDolly(event) {

            const dx = event.touches[0].pageX - event.touches[1].pageX;
            const dy = event.touches[0].pageY - event.touches[1].pageY;

            const distance = Math.sqrt(dx * dx + dy * dy);

            dollyStart.set(0, distance);

        }

        function handleTouchStartDollyPan(event) {

            if (scope.enableZoom) handleTouchStartDolly(event);

            if (scope.enablePan) handleTouchStartPan(event);

        }

        function handleTouchStartDollyRotate(event) {

            if (scope.enableZoom) handleTouchStartDolly(event);

            if (scope.enableRotate) handleTouchStartRotate(event);

        }

        function handleTouchMoveRotate(event) {

            if (event.touches.length == 1) {

                rotateEnd.set(event.touches[0].pageX, event.touches[0].pageY);

            } else {

                const x = 0.5 * (event.touches[0].pageX + event.touches[1].pageX);
                const y = 0.5 * (event.touches[0].pageY + event.touches[1].pageY);

                rotateEnd.set(x, y);

            }

            rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);

            const element = scope.domElement;

            // rotating across whole screen goes 360 degrees around
            scope.rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight); // yes, height

            // rotating up and down along whole screen attempts to go 360, but limited to 180
            scope.rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);

            rotateStart.copy(rotateEnd);

            scope.update();

        }

        function handleTouchMovePan(event) {

            if (event.touches.length == 1) {

                panEnd.set(event.touches[0].pageX, event.touches[0].pageY);

            } else {

                const x = 0.5 * (event.touches[0].pageX + event.touches[1].pageX);
                const y = 0.5 * (event.touches[0].pageY + event.touches[1].pageY);

                panEnd.set(x, y);

            }

            panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);

            scope.pan(panDelta.x, panDelta.y);

            panStart.copy(panEnd);

        }

        function handleTouchMoveDolly(event) {

            const dx = event.touches[0].pageX - event.touches[1].pageX;
            const dy = event.touches[0].pageY - event.touches[1].pageY;

            const distance = Math.sqrt(dx * dx + dy * dy);

            dollyEnd.set(0, distance);

            dollyDelta.set(0, Math.pow(dollyEnd.y / dollyStart.y, scope.zoomSpeed));

            scope.dollyIn(dollyDelta.y);

            dollyStart.copy(dollyEnd);

        }

        function handleTouchMoveDollyPan(event) {

            if (scope.enableZoom) handleTouchMoveDolly(event);

            if (scope.enablePan) handleTouchMovePan(event);

        }

        function handleTouchMoveDollyRotate(event) {

            if (scope.enableZoom) handleTouchMoveDolly(event);

            if (scope.enableRotate) handleTouchMoveRotate(event);

        }

        function handleTouchEnd(/*event*/) {

            // no-op

        }

        //
        // event handlers - FSM: listen for events and reset state
        //

        function onMouseDown(event) {

            // ---------------------------------------------
            // PATCH - mouse statt pointer events, sonst kracht es mit pantouch
            // ---------------------------------------------
            if (scope.enabled === false) return;
            // ---------------------------------------------

            // Prevent the browser from scrolling.

            event.preventDefault();

            // Manually set the focus since calling preventDefault above
            // prevents the browser from setting it automatically.

            scope.domElement.focus ? scope.domElement.focus() : window.focus();

            let mouseAction;

            switch (event.button) {

                case 0:

                    mouseAction = scope.mouseButtons.LEFT;
                    break;

                case 1:

                    mouseAction = scope.mouseButtons.MIDDLE;
                    break;

                case 2:

                    mouseAction = scope.mouseButtons.RIGHT;
                    break;

                default:

                    mouseAction = -1;

            }

            switch (mouseAction) {

                case THREE.MOUSE.DOLLY:

                    if (scope.enableZoom === false) return;

                    handleMouseDownDolly(event);

                    scope.state = STATE.DOLLY;

                    break;

                case THREE.MOUSE.ROTATE:

                    // ---------------------------------------------
                    // PATCH - disableRotate als Option für Camera und panning Standardeingabe falls rotate disabled
                    // ---------------------------------------------
                    if (event.ctrlKey || event.metaKey || event.shiftKey || !scope.enableRotate) {
                        // ---------------------------------------------

                        if (scope.enablePan === false) return;

                        handleMouseDownPan(event);

                        scope.state = STATE.PAN;

                    } else {

                        if (scope.enableRotate === false) return;

                        handleMouseDownRotate(event);

                        scope.state = STATE.ROTATE;

                    }

                    break;

                case THREE.MOUSE.PAN:

                    if (event.ctrlKey || event.metaKey || event.shiftKey) {

                        if (scope.enableRotate === false) return;

                        handleMouseDownRotate(event);

                        scope.state = STATE.ROTATE;

                    } else {

                        if (scope.enablePan === false) return;

                        handleMouseDownPan(event);

                        scope.state = STATE.PAN;

                    }

                    break;

                default:

                    scope.state = STATE.NONE;

            }

            if (scope.state !== STATE.NONE) {

                // ---------------------------------------------
                // PATCH - mouse statt pointer events, sonst kracht es mit pantouch
                // ---------------------------------------------
                scope.domElement.ownerDocument.addEventListener('mousemove', onMouseMove);
                scope.domElement.ownerDocument.addEventListener('mouseup', onMouseUp);
                // ---------------------------------------------

                scope.dispatchEvent(startEvent);

            }

        }

        function onMouseMove(event) {

            // ---------------------------------------------
            // PATCH - mouse statt pointer events, sonst kracht es mit pantouch
            // ---------------------------------------------
            if (scope.enabled === false) return;
            // ---------------------------------------------

            event.preventDefault();

            switch (scope.state) {

                case STATE.ROTATE:

                    if (scope.enableRotate === false) return;

                    handleMouseMoveRotate(event);

                    break;

                case STATE.DOLLY:

                    if (scope.enableZoom === false) return;

                    handleMouseMoveDolly(event);

                    break;

                case STATE.PAN:

                    if (scope.enablePan === false) return;

                    handleMouseMovePan(event);

                    break;

            }

        }

        function onMouseUp(event) {

            scope.removeUpEventListeners();

            if (scope.enabled === false) return;

            handleMouseUp(event);

            scope.dispatchEvent(endEvent);

            scope.state = STATE.NONE;

        }

        function onMouseWheel(event) {

            if (scope.enabled === false || scope.enableZoom === false || (scope.state !== STATE.NONE && scope.state !== STATE.ROTATE)) return;

            // ---------------------------------------------
            // PATCH - mouse wheel zoom event
            // ---------------------------------------------
            scope.state = STATE.DOLLY;
            STAGE.trigger('orbitControlsStart', scope.state);
            // ---------------------------------------------

            event.preventDefault();

            scope.dispatchEvent(startEvent);

            handleMouseWheel(event);

            scope.dispatchEvent(endEvent);

            // ---------------------------------------------
            // PATCH - mouse wheel zoom event
            // ---------------------------------------------
            scope.state = STATE.NONE;
            STAGE.trigger('orbitControlsEnd', scope.state);
            // ---------------------------------------------

        }

        function onKeyDown(event) {

            // ---------------------------------------------
            // PATCH - not inside Form Fields
            // ---------------------------------------------
            const tagname = event.target.tagName.toLowerCase();
            if (tagname === 'input' || tagname === 'select' || tagname === 'textarea') {
                return;
            }
            // ---------------------------------------------

            if (scope.enabled === false || scope.enablePan === false) return;

            handleKeyDown(event);

        }

        function onTouchStart(event) {

            if (scope.enabled === false) return;

            event.preventDefault(); // prevent scrolling

            switch (event.touches.length) {

                case 1:

                    switch (scope.touches.ONE) {

                        case THREE.TOUCH.ROTATE:

                            if (scope.enableRotate === false) return;

                            handleTouchStartRotate(event);

                            scope.state = STATE.TOUCH_ROTATE;

                            break;

                        case THREE.TOUCH.PAN:

                            if (scope.enablePan === false) return;

                            handleTouchStartPan(event);

                            scope.state = STATE.TOUCH_PAN;

                            break;

                        default:

                            scope.state = STATE.NONE;

                    }

                    break;

                case 2:

                    switch (scope.touches.TWO) {

                        case THREE.TOUCH.DOLLY_PAN:

                            if (scope.enableZoom === false && scope.enablePan === false) return;

                            handleTouchStartDollyPan(event);

                            scope.state = STATE.TOUCH_DOLLY_PAN;

                            break;

                        case THREE.TOUCH.DOLLY_ROTATE:

                            if (scope.enableZoom === false && scope.enableRotate === false) return;

                            handleTouchStartDollyRotate(event);

                            scope.state = STATE.TOUCH_DOLLY_ROTATE;

                            break;

                        default:

                            scope.state = STATE.NONE;

                    }

                    break;

                default:

                    scope.state = STATE.NONE;

            }

            if (scope.state !== STATE.NONE) {

                scope.dispatchEvent(startEvent);

            }

        }

        function onTouchMove(event) {

            if (scope.enabled === false) return;

            event.preventDefault(); // prevent scrolling

            switch (scope.state) {

                case STATE.TOUCH_ROTATE:

                    if (scope.enableRotate === false) return;

                    handleTouchMoveRotate(event);

                    scope.update();

                    break;

                case STATE.TOUCH_PAN:

                    if (scope.enablePan === false) return;

                    handleTouchMovePan(event);

                    scope.update();

                    break;

                case STATE.TOUCH_DOLLY_PAN:

                    if (scope.enableZoom === false && scope.enablePan === false) return;

                    handleTouchMoveDollyPan(event);

                    scope.update();

                    break;

                case STATE.TOUCH_DOLLY_ROTATE:

                    if (scope.enableZoom === false && scope.enableRotate === false) return;

                    handleTouchMoveDollyRotate(event);

                    scope.update();

                    break;

                default:

                    scope.state = STATE.NONE;

            }

        }

        function onTouchEnd(event) {

            if (scope.enabled === false) return;

            handleTouchEnd(event);

            scope.dispatchEvent(endEvent);

            scope.state = STATE.NONE;

        }

        function onContextMenu(event) {

            if (scope.enabled === false) return;

            event.preventDefault();

        }

        //

        scope.domElement.addEventListener('contextmenu', onContextMenu);

        // ---------------------------------------------
        // PATCH - mouse statt pointer events, sonst kracht es mit pantouch
        // ---------------------------------------------
        scope.domElement.addEventListener('mousedown', onMouseDown);
        // ---------------------------------------------

        scope.domElement.addEventListener('wheel', onMouseWheel);

        scope.domElement.addEventListener('touchstart', onTouchStart);
        scope.domElement.addEventListener('touchend', onTouchEnd);
        scope.domElement.addEventListener('touchmove', onTouchMove);

        // ---------------------------------------------
        // PATCH - additional public methods
        // ---------------------------------------------
        this.setEnabled = (on) => {
            scope.enabled = on;
            scope.state = STATE.NONE;
        };
        this.processTarget = target => {
        };
        this.getPan = () => panOffset;
        // ---------------------------------------------

        // ---------------------------------------------
        // PATCH - altes Verhalten als default unterstützt
        // ---------------------------------------------
        if (registerDefaultKeylistnener) {
            this.listenToKeyEvents(scope.domElement);

            // make sure element can receive keys.
            if (scope.domElement.tabIndex === -1) {
                scope.domElement.tabIndex = 0;
            }
        }
        // ---------------------------------------------

        // force an update at start

        this.update();

    }

}

// This set of controls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
// This is very similar to OrbitControls, another set of touch behavior
//
//    Orbit - right mouse, or left mouse + ctrl/meta/shiftKey / touch: two-finger rotate
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - left mouse, or arrow keys / touch: one-finger move


class MapControls extends OrbitControls {

    constructor( object, domElement ) {

        super( object, domElement );
        this.screenSpacePanning = false; // pan orthogonal to world-space direction camera.up

        this.mouseButtons.LEFT = THREE.MOUSE.PAN;
        this.mouseButtons.RIGHT = THREE.MOUSE.ROTATE;
        this.touches.ONE = THREE.TOUCH.PAN;
        this.touches.TWO = THREE.TOUCH.DOLLY_ROTATE;

    }

}

THREE.MapControls = MapControls;
THREE.OrbitControls = OrbitControls;

